import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import WarningIcon from "@material-ui/icons/Warning";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import InfoIcon from '@mui/icons-material/Info';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setBotErrorList } from '../../redux-store/actions';
import styles from './MultiSelectionDropdown.module.css';
const MultiSelectionDropdown = ({options, showBotErrorDropDown,setShowBotErrorDropDown ,resetSelecteBotError,setRsetSelecteBotError,resetClick}) => {

  const dispatch= useDispatch()
  const [fileInput, setFileInput] = useState(null);
  const [showDropdown, setShowdropdown] = useState(false)
  const [optionList, setOptionList] = useState([])
  const [showSelectedOption, setShowSelectedOption] = useState("More Option")

  const [selectedOptionList, setSelectedOptionList] = useState([])

  // console.log("resetClick",resetClick)

  useEffect(()=>{
    if(options){
      let dataList = options.map((item)=>{
        return {
          ...item,
          isChecked:false
        }
      })
      setOptionList([...dataList])
    }

  },[options])


  useEffect(()=>{
    if(resetSelecteBotError){
      // alert("Hello")
      setSelectedOptionList(()=>[])
      let dataList = optionList.map((item)=>{
        return {
          ...item,
          isChecked:false
        }
      })
      setOptionList([...dataList])
      setRsetSelecteBotError(false)
    }

  },[resetSelecteBotError])


const onChangeHandler=(e, data)=>{
  if (e.target.checked) {
    let arr = optionList;
    // let list = callSource;
    // NOTE:- here we are making a check box true
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].value === data.value) {
        arr[i].isChecked = true;
      }
    }
    setOptionList(()=>[...arr])
    let dataList = arr.filter(item=>item.isChecked)
    setSelectedOptionList((prevState)=>[... dataList])

     dispatch(setBotErrorList(dataList))
    
  } else {
    let arr = optionList;

    let list = optionList;

    // // NOTE:- here we are making a check box false
    for (let i = 0; i < list.length; i++) {
      if (list[i].value ===data.value) {
        list[i].isChecked = false;

      }
    }
    setOptionList([...list])
    let dataList = arr.filter(item=>item.isChecked)
    setSelectedOptionList((prevState)=>[... dataList])
    dispatch(setBotErrorList(dataList))


}
}

const ShowIcon =(Type)=>{
  const {type} = Type
  if(type==="NO_RESPONSE_FROM_SERVER"){
    return(

      <InfoIcon  style={{ color: "#f57242", fontSize: "18px" }}/>
    ) 
  }
  else if (type==="ESCALATED"){
    return <WarningIcon
    style={{ color: "red", fontSize: "18px" }}
  />
  }else if (type==="PANDING_MANUAL_ORDER")
  {
    return  <span style={{width:"12px", height:"12px ", background:"red", textAlign:"center",fontWeight:"bold",color:"white",fontSize:"12px", paddingLeft:"2px", paddingRight:"2px" }}>M</span>
  }else if (type==="SUCCESSFUL_MANUAL_ORDER"){
    return  <span style={{width:"12px", height:"12px ", background:"green", textAlign:"center",fontWeight:"bold",color:"white",fontSize:"12px", paddingLeft:"2px", paddingRight:"2px"}}>M</span>
   
  }else {
    return ""
  }
}
  return (
    <div className={styles.multiSelectionDropdown}>

        <div className={styles.multiSelectionDropdown__inputBox} onClick={()=>setShowBotErrorDropDown(!showBotErrorDropDown)}>
            <div className={styles.selected_options}>{selectedOptionList&& selectedOptionList.length>0 ? `${selectedOptionList.length} selected`:showSelectedOption} </div>
            <div className={styles.dropdownIcon}> {showBotErrorDropDown ? <ArrowDropUpIcon/>:<ArrowDropDownIcon/> }</div>

        </div>
        <div className={styles.dropdownBox} style={{display:!showBotErrorDropDown &&"none"}}>
          {/* <div className={styles.selectOption}>
            <div style={{display:"flex", alignItems:"center"}} >
              <input type='checkbox'/> <p style={{marginLeft:"5px"}}> Select All</p>

            </div>
          </div> */}
        { optionList && optionList.map((item)=>
        

          <div className={styles.option} 
          //  onClick={() => fileInput.click()}
           >
           <div>
           <input type='checkbox'
            className={styles.inputCheckbox}

              checked={item.isChecked}

              onChange={(e)=>onChangeHandler(e, item)}
                  // ref={(fileInputref) => setFileInput(fileInputref)}
            
              />
           </div>

          
            <p className={styles.text}>{(item.label)} <ShowIcon type={item.value}/></p>
          </div>
        )}

        </div>
    </div>
  )
}

export default MultiSelectionDropdown